<div class="card custom-box border-0" style="margin-top: -1.4rem;">
  <div id="confirm-enroll-type-panel" class="card-body">
    <div class="row">
      <div class="col">
        <div class="card border-0">
          <div class="card-body text-center">
            <button (click)="register()" class="btn btn-primary btn-custom mx-2">ลงทะเบียน</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
